import { useState } from "react";
import type { SnapshotPhoto } from "../../shared/types";
import { photoUrl } from "../lib/api";
import { PhotoLightbox } from "./PhotoLightbox";

interface Props {
  photos: SnapshotPhoto[];
}

export function PhotoGallery({ photos }: Props) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  if (photos.length === 0) return null;
  const visible = photos.slice(0, 12);
  return (
    <>
      <div className="-mx-5 overflow-x-auto">
        <div className="flex gap-2 px-5">
          {visible.map((p, i) => (
            <button
              key={p.key}
              type="button"
              onClick={() => setActiveIndex(i)}
              className="block shrink-0 overflow-hidden rounded-xl border border-white/10 bg-slate-900/80 transition hover:border-white/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/40"
            >
              {/*
                サムネイルと拡大表示で同じ URL を使うことで、
                Lightbox 側は HTTP キャッシュから読み込み、
                R2 への追加リクエストを回避する。
              */}
              <img
                src={photoUrl(p.key)}
                alt=""
                loading="lazy"
                decoding="async"
                className="h-28 w-auto max-w-[14rem] object-cover"
              />
            </button>
          ))}
        </div>
      </div>
      {activeIndex !== null && (
        <PhotoLightbox
          photos={visible}
          initialIndex={activeIndex}
          onClose={() => setActiveIndex(null)}
        />
      )}
    </>
  );
}
